import { createSlice } from "@reduxjs/toolkit";

const admissionsSlice = createSlice({
  name: "admissions",
  initialState: {
    admission: {},
    status: "idle", // "idle", "loading", "succeeded", "failed"
    admissionError: null, // to store any admissionError messages
  },
  reducers: {
    // Action when admission data is being loaded
    loadAdmissionsStart: (state) => {
      state.status = "loading"; // Set the status to loading when the request starts
      state.admissionError = null; // Clear any previous admissionError
    },

    // Action when admission data is successfully loaded
    loadAdmissionsSuccess: (state, action) => {
      state.status = "succeeded"; // Set the status to succeeded
      state.admissions = action.payload; // Update the admissions array with the fetched data
    },

    // Action when there is an admissionError while loading data
    loadAdmissionsFailure: (state, action) => {
      state.status = "failed"; // Set the status to failed
      state.admissionError = action.payload; // Store the admissionError message
    },

    // Action to add a new admission
    addAdmission: (state, action) => {
      state.admissions.push(action.payload); // Add the new admission to the array
    },
  },
});

// Export actions
export const {
  loadAdmissionsStart,
  loadAdmissionsSuccess,
  loadAdmissionsFailure,
  addAdmission,
} = admissionsSlice.actions;

export default admissionsSlice.reducer;
